
  import { defineComponent, PropType } from 'vue';

  import { getPreviousYearByYear } from '@/common/utils/year';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';

  import { ALL_YEAR_OPTION } from '../../constants/dashboards';
  import { TTopPartnerRating } from '../../types/dashboards';

  export default defineComponent({
    name: 'TopStatisticChart',
    components: {
      EChartsHorizontalBar,
    },
    emits: ['barClick'],
    props: {
      items: {
        type: Array as PropType<TTopPartnerRating[]>,
        required: true,
      },
      year: {
        type: String,
        required: true,
      },
      isLoading: {
        type: Boolean,
      },
      isBarClickable: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      chartHeight(): number {
        return Math.max(280, this.items.length * 48 + 80);
      },
      chartLabels(): string[] {
        return this.items.map((item: TTopPartnerRating, index: number) => `${index + 1}. ${item.name}`);
      },
      chartDataset() {
        const currentYear = this.items.map((item: TTopPartnerRating) => item.requestedYearValue || 0);
        const lastYear = this.items.map((item: TTopPartnerRating) => item.lastYearValue || 0);

        const dataset = [
          {
            data: currentYear,
            label: this.year === ALL_YEAR_OPTION.value ? 'За все время' : this.year,
            color: '#0078C8',
          },
        ];

        if (this.year !== ALL_YEAR_OPTION.value) {
          dataset.push({
            data: lastYear,
            label: `${getPreviousYearByYear(this.year)}`,
            color: '#BAD7F3',
          });
        }

        return dataset;
      },
    },
    methods: {
      onClickedBar(dataIndex: number | null, seriesIndex: number | null) {
        if (!this.isBarClickable || dataIndex == null) return;

        const item = this.items[dataIndex];
        if (item) this.$emit('barClick', { item, datasetIndex: seriesIndex ?? 0 });
      },
    },
  });
